import Vue from 'vue'

import Item from './Item.vue'
import Items from './Items.vue'
import ItemEdit from './ItemEdit'
import ItemCreate from './ItemCreate'
import CoachingContentsTable from './patients/CoachingContentsTable'
import ContentAdditionModule from './patients/ContentAdditionModule'
import ContentDeactivationModal from './patients/ContentDeactivationModal'
import ContentEditModal from './patients/ContentEditModal'

import { classes, DraftUserAction, DraftUserLesson } from '../structs/structs'
import { EditActionModal, EditLessonModal } from '../forms/forms'
import { constructValidator } from '../forms/validations'

export const Actions = Vue.extend(
  {
    ...Items,
    name: 'Actions'
  }
)

export const Lessons = Vue.extend(
  {
    ...Items,
    name: 'Lessons'
  }
)

export const Action = Vue.extend(
  {
    ...Item,
    name: 'Action'
  }
)

export const ActionCreate = Vue.extend(
  {
    ...ItemCreate,
    name: 'ActionCreate'
  }
)

export const ActionEdit = Vue.extend(
  {
    ...ItemEdit,
    name: 'ActionEdit'
  }
)

export const Lesson = Vue.extend(
  {
    ...Item,
    name: 'Lesson'
  }
)

export const LessonCreate = Vue.extend(
  {
    ...ItemCreate,
    name: 'LessonCreate'
  }
)

export const LessonEdit = Vue.extend(
  {
    ...ItemEdit,
    name: 'LessonEdit'
  }
)

export const ActionTable = Vue.extend(
  {
    ...CoachingContentsTable,
    name: 'ActionTable'
  }
)

export const LessonTable = Vue.extend(
  {
    ...CoachingContentsTable,
    name: 'LessonTable'
  }
)

export const ActionAdditionModule = Vue.extend(
  {
    ...ContentAdditionModule,
    name: 'ActionAdditionModule'
  }
)

export const ActionPlanAdditionModule = Vue.extend(
  {
    ...ContentAdditionModule,
    name: 'ActionPlanAdditionModule'
  }
)

export const LessonAdditionModule = Vue.extend(
  {
    ...ContentAdditionModule,
    name: 'LessonAdditionModule'
  }
)

export const LessonPlanAdditionModule = Vue.extend(
  {
    ...ContentAdditionModule,
    name: 'LessonPlanAdditionModule'
  }
)

export const ActionEditModal = Vue.extend(
  {
    ...ContentEditModal,
    name: 'ActionEditModal',
    data () {
      return {
        modalForm: EditActionModal,
        selectedDraftContent: new DraftUserAction(this.content || {})
      }
    },
    computed: {
      itemType () { return 'action' },
      formId () { return `edit-action-form-${this._uid}` },
      modalId () { return `edit-action-modal-${this._uid}` },
      inputGroupKey () { return `action-${this.content.data.id}` },
      formValidator () { return constructValidator($, this.formId, 'action', 'modal', this.constructCustomValidatorSetters()) }
    },
    methods: {
      ...ContentEditModal.methods,
      initializeFormValidator () {
        this.formValidator()
      },
      constructCustomValidatorSetters () {
        return jQuery => {
          return () => {
            jQuery.fn.form.settings.rules.endDayAfterStartDay = () => {
              return (parseInt(this.selectedDraftContent.data.options.endDay) >= parseInt(this.selectedDraftContent.data.options.startDay))
            }
          }
        }
      }
    }
  }
)

export const LessonEditModal = Vue.extend(
  {
    ...ContentEditModal,
    name: 'LessonEditModal',
    data () {
      return {
        modalForm: EditLessonModal,
        selectedDraftContent: new DraftUserLesson(this.content || {})
      }
    },
    computed: {
      itemType () { return 'lesson' },
      formId () { return `edit-lesson-form-${this._uid}` },
      modalId () { return `edit-lesson-modal-${this._uid}` },
      inputGroupKey () { return `lesson-${this.content.data.id}` },
      formValidator () { return constructValidator($, this.formId, 'lesson', 'modal') }
    },
    methods: {
      ...ContentEditModal.methods,
      initializeFormValidator () { this.formValidator() }
    }
  }
)

export const ActionDeactivationModal = Vue.extend(
  {
    ...ContentDeactivationModal,
    name: 'ActionDeactivationModal',
    props: {
      ...ContentDeactivationModal.props,
      content: {
        type: classes.Action,
        required: true
      }
    },
    computed: {
      itemType () { return 'action' },
      modalId () { return `deactivate-action-modal-${this._uid}` }
    }
  }
)

export const LessonDeactivationModal = Vue.extend(
  {
    ...ContentDeactivationModal,
    name: 'LessonDeactivationModal',
    props: {
      ...ContentDeactivationModal.props,
      content: {
        type: classes.Lesson,
        required: true
      }
    },
    computed: {
      itemType () { return 'lesson' },
      modalId () { return `deactivate-lesson-modal-${this._uid}` }
    }
  }
)
